import { Close, Edit } from "@mui/icons-material";
import {
    TextField,
    Select,
    FormControl,
    TableCell,
    TableRow,
    IconButton,
    Autocomplete
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { FormatDate, GetDateObject } from "commonFunctions/commonFunctions";
import React, { useEffect, useMemo, useState } from "react";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateField } from '@mui/x-date-pickers/DateField';
import * as c from "utils/constants/constants";

const staticKeyList = {
    "Patient Name": "additionalPatientName",
    "Patient Date of Birth": "additionalDateOfBirth",
    "Address": "additional_address",
    "Phone Number": "additional_phone",
    "To": "additional_provider_details",
}

const EditRowItem = (props) => {
    const [editingObj, setEditingObj] = useState({});
    const sortedNormalizedKeys = useMemo(() => {
        return props.keyOrders.filter(m => m == props.data.normalized || !props.availableOptions.includes(m))
    }, [props.selectedObj]);

    useEffect(() => {
        setEditingObj(props.data);
    }, [props.selectedObj]);

    const handleChange = (key, value) => {
        let temp = { ...editingObj };
        temp[key] = value;
        temp.modified = true;
        setEditingObj({ ...temp });
        props.handleChange(editingObj.id, temp);
    }

    const getOptions = () => {
        const { Entity_Details = {} } = props.documentData || {};
        return Entity_Details[staticKeyList[editingObj.normalized]] || [];
    }

    return <TableRow
        key={editingObj.id}
        sx={{ 
            // '&:last-child td, &:last-child th': { border: 0 },
            "td": {
                padding: "unset !important"
            },
        }}
    >
        <TableCell scope="row">
            <div
                className={
                    editingObj.modified === true
                        ? "card-flag"
                        : "card-flag-hide"
                }
            >
                <div className="tri-flag" />
            </div>
            <div className="cell-container">
                <FormControl variant="standard" style={{ width: "100%" }}>
                    <Select
                        native
                        value={editingObj.normalized || ""}
                        margin="dense"
                        onChange={event => handleChange("normalized", event.target.value)}
                        inputProps={{
                            name: "normalised",
                            id: "outlined-age-native-simple",
                        }}
                    >
                        <option value="" disabled>
                            Select key
                        </option>
                        {(sortedNormalizedKeys || []).map((key, i) => (
                            <option key={i} value={key}>
                                {key}
                            </option>
                        ))}
                    </Select>
                </FormControl>
            </div>
        </TableCell>
        <TableCell scope="row">
            <div className="cell-container">
                <TextField
                    variant="standard"
                    style={{ width: "100%" }}
                    autoComplete="off"
                    name="label_type"
                    value={editingObj.key}
                    onChange={event => handleChange("key", event.target.value)}
                />
            </div>
        </TableCell>
        <TableCell scope="row">
            <div className="cell-container">
                {editingObj.normalized == "Patient Date of Birth" ? <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DateField']}>
                        <DateField
                            variant="standard"
                            size="small"
                            value={!editingObj.value ? null : GetDateObject(editingObj.value)}
                            format="MM/DD/YYYY"
                            onChange={(date, context) => {
                                if (!context.validationError)
                                    handleChange("value", FormatDate({ date, format: "MM/DD/YYYY" }))
                            }}
                            style={{ width: "100%" }}
                        />
                    </DemoContainer>
                </LocalizationProvider> :
                    (props.documentData.Status == c.status.processed || props.documentData.Status == c.status.intervention_rqd &&
                        props.keyOrders?.includes(editingObj.normalized) &&
                        editingObj.normalized != "Patient Date of Birth") ? <Autocomplete
                        options={(getOptions())?.map((key, i) => key.value)}
                        value={editingObj.value}
                        freeSolo={true}
                        onInputChange={(event, newValue) => {
                            handleChange("value", newValue)
                        }
                        }
                        sx={{ width: "100%" }}
                        renderInput={(params) => (
                            <TextField {...params} variant="standard" label="" placeholder={editingObj.normalized == "Patient Name" ? "First Name, Last Name": ""} />
                        )}
                    /> : <TextField
                        variant="standard"
                        style={{ width: "100%" }}
                        autoComplete="off"
                        name="value_types"
                        value={editingObj.value}
                        placeholder={editingObj.normalized == "Patient Name" ? "First Name, Last Name": ""}
                        onChange={event => handleChange("value", event.target.value)}
                    />}
            </div>
        </TableCell>
        <TableCell align='center'>
                <IconButton>
                    <Close className='icon-review-style' onClick={props.handleCancel}/>
                </IconButton>
        </TableCell>
    </TableRow>
}

export default EditRowItem;